import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Give Us a Shout`}</h1>
    <p>{`He was an expert but not in a discipline that anyone could fully appreciate. He knew how to hold the cone just right so
that the soft server ice-cream fell into it at the precise angle to form a perfect cone each and every time. It had taken
years to perfect and he could now do it without even putting any thought behind it. Nobody seemed to fully understand the
beauty of this accomplishment except for the new worker who watched in amazement. Feel free to `}<a parentName="p" {...{
        "href": "mailto:abcd@efg.com"
      }}>{`get in touch with me`}</a>{`
or message me at `}<a parentName="p" {...{
        "href": "https://twitter.com/twitter"
      }}>{`Twitter`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      